export default __webpack_public_path__ + "static/media/167.4bb34b5b.jpg";